import { jsx as _jsx } from "react/jsx-runtime";
import { createElement } from 'react';
import { renderChildren } from './renderChildren';
import { RenderElementFallback } from './RenderElementFallback';
import { resolveRichTextElementMetadata } from './resolveRichTextElementMetadata';
import { useRichTextRenderMetadata } from './RichTextRenderMetadataContext';
export function ElementRenderer({ element, children, options }) {
    const metadata = useRichTextRenderMetadata();
    const elementMetadata = resolveRichTextElementMetadata(element, metadata);
    const fallback = (_jsx(RenderElementFallback, Object.assign({ element: element, options: options }, { children: children }), void 0));
    return options.renderElement
        ? createElement(options.renderElement, {
            ...elementMetadata,
            element,
            fallback,
            children,
            renderChildren,
            renderChildrenOptions: options,
        })
        : fallback;
}
//# sourceMappingURL=ElementRenderer.js.map